import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'Hoelang duurt het?',
    answer: 'Het webinar duurt ongeveer 90 minuten, vol met waardevolle inzichten en tijd voor jouw vragen.'
  }, {
    question: 'Kan ik het terugkijken?',
    answer: 'Ja, absoluut! Iedereen ontvangt achteraf een opname in de mail. Je hoeft je dus geen zorgen te maken als er onverwachts iets tussenkomt.'
  }, {
    question: 'Wordt er iets verkocht?',
    answer: 'Aan het einde van het webinar doe ik een aanbod voor degenen die verder willen leren, maar de 90 minuten zitten bomvol gratis, direct toepasbare waarde. Plus, je krijgt achteraf een waardevolle bonus!'
  }, {
    question: 'Ik heb achteraf nog een vraag, kan ik die dan nog stellen?',
    answer: 'Natuurlijk. Tijdens het webinar beantwoord ik vragen in de chat. Heb je later nog vragen? Dan mag je me altijd mailen op amee@stresslessdogs.nl.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-lightMint py-20 px-4 sm:px-6 lg:px-8" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <div className="text-center mb-12" data-id="element-61">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800" data-id="element-62">
            Veelgestelde Vragen
          </h2>
        </div>

        <div className="space-y-4" data-id="element-63">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`bg-white rounded-2xl border transition-all duration-200 overflow-hidden ${isOpen ? 'border-brand-mint shadow-md' : 'border-teal-100 shadow-sm'}`} data-id="element-64">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-65">
                  <span className="font-semibold text-slate-800 text-lg pr-8" data-id="element-66">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-mint flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-67" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-68">
                  <p className="text-gray-600 leading-relaxed" data-id="element-69">{faq.answer}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}